import React from 'react';
import PropTypes from 'prop-types';
import styles from './ContactList.module.scss';
import CardContact from '../CardContact';

const ContactList = ({ title, text, items }) => {
    return (
        <div className={styles['ContactList']}>
            <div className={styles['ContactList__Header']}>
                {!!title && (
                    <h2 className={styles['ContactList__Title']}>{title}</h2>
                )}
                {!!text && (
                    <p className={styles['ContactList__Text']}>{text}</p>
                )}
            </div>
            <div className={styles['ContactList__Container']}>
                {items.map((item, i) => (
                    <div className={styles['ContactList__Item']} key={i}>
                        <CardContact {...item} />
                    </div>
                ))}
            </div>
        </div>
    );
};

ContactList.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    items: PropTypes.array,
};

ContactList.defaultProps = {
    title: '',
    text: '',
    items: [],
};

export default ContactList;
